import { useState } from 'react';
import { useIntl } from 'react-intl';

import { ExperienceBlock } from '@sorare/core/src/components/landing/ExperienceBlock';
import { messages } from '@sorare/core/src/components/landing/LandingMultiSport/Experience';
import useEvents from '@sorare/core/src/lib/events/useEvents';

import { MarketPlaceDialog } from './MarketPlaceDialog';
import competeImage from './assets/competeImage.jpg';
import competeImageMobile from './assets/competeImageMobile.jpg';
import createImage from './assets/createImage.jpg';
import createImageMobile from './assets/createImageMobile.jpg';
import strengthenImage from './assets/strengthenImage.jpg';
import strengthenImageMobile from './assets/strengthenImageMobile.jpg';
import winRewardsImage from './assets/winRewardsImage.jpg';
import winRewardsImageMobile from './assets/winRewardsImageMobile.jpg';

export const Experience = () => {
  const track = useEvents();
  const { formatMessage } = useIntl();
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      <ExperienceBlock
        title={formatMessage({
          id: 'Landing.Experience.title2',
          defaultMessage:
            'Experience Fantasy Baseball Like A Pro General Manager',
        })}
        blocks={[
          {
            title: formatMessage(messages.createTitle),
            text: formatMessage(messages.createText, { br: <br /> }),
            imageSrc: { default: createImage, mobile: createImageMobile },
          },
          {
            title: formatMessage(messages.competeTitle),
            text: formatMessage(messages.competeText),
            imageSrc: { default: competeImage, mobile: competeImageMobile },
          },
          {
            title: formatMessage(messages.strengthenTitle),
            text: formatMessage(messages.strengthenText),
            cta: formatMessage(messages.strengthenCTA),
            ctaAction: () => {
              track('Click Scout the Marketplace');
              setOpenDialog(true);
            },
            imageSrc: {
              default: strengthenImage,
              mobile: strengthenImageMobile,
            },
          },
          {
            title: formatMessage(messages.winRewardsTitle),
            text: formatMessage(messages.winRewardsText, { br: <br /> }),
            imageSrc: {
              default: winRewardsImage,
              mobile: winRewardsImageMobile,
            },
          },
        ]}
      />
      <MarketPlaceDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
      />
    </>
  );
};
